<template>
	<FormDropdown
		:label="`<i class='far fa-object-group'></i> <b> Agrupar por: </b> ${agrupamentosFormatados} <i class='fas fa-chevron-down'></i>`"
	>
		<div class="container__regras__de__agrupamento">
			<p>{{ $t('selectMultipleCriterion') }}</p>
			<div
				v-for="(agrupamento, index) in opcoesDeAgrupamentosOrdenados"
				:key="index"
				class="container__regras__de__agrupamento__item"
			>
				<DropdownPrioridadeAgrupamento
					:id="agrupamento.id"
					v-model="agrupamento.prioridade"
					semantic-class="mini"
					:options="opcoesDePrioridades"
					@repriorizar="repriorizarAgrupamentos"
				/>
				<p>{{ agrupamento.descricao }}</p>
			</div>
		</div>
	</FormDropdown>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import DropdownPrioridadeAgrupamento from './DropdownPrioridadeAgrupamento/DropdownPrioridadeAgrupamento'
import FormDropdown from '../../../../../components/FormDropdown/FormDropdown'

export default {
	components: {
		DropdownPrioridadeAgrupamento,
		FormDropdown,
	},
	data() {
		return {
			opcoesDeAgrupamentos: [
				{
					id: uuidv4(),
					prioridade: null,
					descricao: this.$t('proximity'),
					value: 'PROXIMIDADE',
					nomePropriedade: '',
				},
				{
					id: uuidv4(),
					prioridade: null,
					descricao: this.$t('lastMeasurement'),
					value: 'DATADAULTIMAMEDICAO',
					nomePropriedade: 'dataDaUltimaMedicao',
				},
				{
					id: uuidv4(),
					prioridade: null,
					descricao: this.$t('plantationDate'),
					value: 'DATADOPLANTIO',
					nomePropriedade: 'dataDoPlantio',
				},
				{
					id: uuidv4(),
					prioridade: null,
					descricao: this.$t('plantingAnniversary'),
					value: 'ANIVERSARIODOPLANTIO',
					nomePropriedade: '',
				},
				{
					id: uuidv4(),
					prioridade: null,
					descricao: this.$t('geneticMaterial'),
					value: 'MATERIALGENETICO',
					nomePropriedade: 'materialGeneticoId',
				},
			],
		}
	},
	computed: {
		agrupamentosFormatados() {
			return this.opcoesDeAgrupamentos
				.filter((agrupamento) => agrupamento.prioridade)
				.map((agrupamento) => agrupamento.descricao)
				.join(', ')
		},
		opcoesDePrioridades() {
			const opcoesAgrupamentos = this.opcoesDeAgrupamentos.map((_, indice) => {
				return {
					value: indice + 1,
					label: `${indice + 1} º`,
				}
			})

			opcoesAgrupamentos.unshift({ value: null, label: '-' })

			return opcoesAgrupamentos
		},
		opcoesDeAgrupamentosOrdenados() {
			return this.opcoesDeAgrupamentos.slice().sort((agrupamento1, agrupamento2) => {
				if (agrupamento1.prioridade === agrupamento2.prioridade) return 0
				else if (agrupamento1.prioridade === null) return 1
				else if (agrupamento2.prioridade === null) return -1
				return agrupamento1.prioridade - agrupamento2.prioridade
			})
		},
	},
	methods: {
		repriorizarAgrupamentos(prioridadeNova, prioridadeAntiga, id) {
			if (prioridadeAntiga == null) {
				// Caso a prioridade antiga do agrupamento seja nula, deve incrementar todos os valores que sejam igual ou maior que a prioridade nova que foi setada, caso ja exista um valor igual a prioridade nova
				const prioridadeJaSetada = this.opcoesDeAgrupamentos
					.filter((agrupamento) => agrupamento.id !== id)
					.map((agrupamento) => agrupamento.prioridade)
					.some((prioridade) => prioridade === prioridadeNova)

				if (prioridadeJaSetada) {
					this.opcoesDeAgrupamentos
						.filter(
							(agrupamento) =>
								agrupamento.prioridade &&
								agrupamento.prioridade >= prioridadeNova &&
								agrupamento.id !== id,
						)
						.forEach((agrupamento) => {
							agrupamento.prioridade++
						})
				}
			} else if (prioridadeNova == null) {
				// Caso a prioridade nova seja nula, deve decrementar todos os valores que sejam igual ou maior que a prioridade antiga que foi setada
				this.opcoesDeAgrupamentos
					.filter(
						(agrupamento) =>
							agrupamento.prioridade &&
							agrupamento.prioridade >= prioridadeAntiga &&
							agrupamento.id !== id,
					)
					.forEach((agrupamento) => {
						agrupamento.prioridade--
					})
			} else if (prioridadeNova < prioridadeAntiga) {
				// Caso a prioridade nova seja menor que a antiga, deve incrementar todos os valores que sejam maior ou igual que a prioridade nova e menores do que a prioridade antiga
				this.opcoesDeAgrupamentos
					.filter(
						(agrupamento) =>
							agrupamento.prioridade &&
							agrupamento.prioridade >= prioridadeNova &&
							agrupamento.prioridade < prioridadeAntiga &&
							agrupamento.id !== id,
					)
					.forEach((agrupamento) => {
						agrupamento.prioridade++
					})
			} else if (prioridadeNova > prioridadeAntiga) {
				// Caso a prioridade nova seja maior que a antiga, deve decrementar todos os valores que sejam menor ou igual a prioridade nova e maiores que a prioridade antiga
				this.opcoesDeAgrupamentos
					.filter(
						(agrupamento) =>
							agrupamento.prioridade &&
							agrupamento.prioridade <= prioridadeNova &&
							agrupamento.prioridade > prioridadeAntiga &&
							agrupamento.id !== id,
					)
					.forEach((agrupamento) => {
						agrupamento.prioridade--
					})
			}
			this.informarAlteracaoDeRegraDeAgrupamento()
		},
		informarAlteracaoDeRegraDeAgrupamento() {
			this.$emit('regraAgrupamentoMudou', this.opcoesDeAgrupamentos)
		},
	},
}
</script>

<style scoped>
.container__regras__de__agrupamento {
	display: flex;
	flex-direction: column;
	font-weight: 400;
	line-height: normal;
}

.container__regras__de__agrupamento > p {
	color: var(--color-gray-dark);
	font-size: 0.75rem;
}

.container__regras__de__agrupamento__item {
	font-size: 0.875rem;
	display: flex;
	align-items: center;
	margin-top: 0.5rem;
}

.container__regras__de__agrupamento__item > p {
	margin: 0;
	margin-left: 1rem;
}
</style>
